import { render, staticRenderFns } from "./AwsFilesEdit.vue?vue&type=template&id=38eb73c2&scoped=true"
import script from "./AwsFilesEdit.vue?vue&type=script&lang=ts"
export * from "./AwsFilesEdit.vue?vue&type=script&lang=ts"
import style0 from "./AwsFilesEdit.vue?vue&type=style&index=0&id=38eb73c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb73c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38eb73c2')) {
      api.createRecord('38eb73c2', component.options)
    } else {
      api.reload('38eb73c2', component.options)
    }
    module.hot.accept("./AwsFilesEdit.vue?vue&type=template&id=38eb73c2&scoped=true", function () {
      api.rerender('38eb73c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/AwsFilesEdit.vue"
export default component.exports